export default __webpack_public_path__ + "static/media/AMNH_10.0d93beee.png";